export default class SliderHomeEnum {
    static CONTAINER_STRATE_1 = '#strate-1'
    static CONTAINER_STRATE_VISITER = '#strate-visiter'
    static CONTAINER_STRATE_START_TRIP = '#strate-startTrip'
    static CONTAINER_STRATE_DISCOVER = '#strate-discover'
    static CONTAINER_STRATE_ITINERARY = '#strate-itinerary'
    static CONTAINER_STRATE_EVENT = '#strate-event'
    static CONTAINER_STRATE_SEJOUR = '#strate-sejour'
}
